//#region src/utils/dragSelect.ts
function isInsideDragRect(dragRect, rect) {
	return rect.x >= dragRect.x && rect.y >= dragRect.y && rect.x + rect.w <= dragRect.x + dragRect.w && rect.y + rect.h <= dragRect.y + dragRect.h;
}
function isOverlapPosition(dragRect, rect) {
	return !(dragRect.x > rect.x + rect.w || dragRect.x + dragRect.w < rect.x || dragRect.y > rect.y + rect.h || dragRect.y + dragRect.h < rect.y);
}
//#endregion
export { isInsideDragRect, isOverlapPosition };
